import React from 'react';

interface Props {
  label: string;
  value: string;
}

export const DetailsRow: React.FC<Props> = ({ label, value }) => (
  <div className="flex items-start justify-between gap-3">
    <p className="text-body-14 shrink-0 text-muted-foreground">{label}</p>
    <p className="text-body-14 text-right text-foreground">{value}</p>
  </div>
);
